import { DEFAULT_VIEW_PREFERENCES, normalizeViewPreferences, type ViewPreferences } from "./types";

const VIEW_PREFERENCES_KEY = "prifetcher.viewPreferences";

export function loadViewPreferences(storage: Pick<Storage, "getItem"> = window.localStorage): ViewPreferences {
  try {
    const saved = storage.getItem(VIEW_PREFERENCES_KEY);
    if (saved) return normalizeViewPreferences(JSON.parse(saved));
    return { ...DEFAULT_VIEW_PREFERENCES };
  } catch {
    return { ...DEFAULT_VIEW_PREFERENCES };
  }
}

export function saveViewPreferences(
  preferences: ViewPreferences,
  storage: Pick<Storage, "setItem"> = window.localStorage,
): ViewPreferences {
  const normalized = normalizeViewPreferences(preferences);
  storage.setItem(VIEW_PREFERENCES_KEY, JSON.stringify(normalized));
  return normalized;
}
